import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import Modes from '../../contexts/Modes';
import RouteNames from '../../contexts/RouteNames';
import useWindowDimensions from '../../helpers/useWindowDimensions';
import { fetchStaticResourceMap } from '../../services/OrderService';
import Themes from '../../styles/Themes';
import { CardList } from './CardList';
import { Footer } from './Footer';
import { Header } from './Header';

const Wrapper = styled.div`
background-color: ${props => props.colorTheme.backgroundColor};
display: flex;
flex-direction: column;
height: ${({ height }) => height - 100}px;
overflow-x: hidden;
overflow-y: auto;
padding: 20px 10px 20px 10px;
width: 100%;
`;

const Container = styled.nav`
  margin: auto;
  height: 100%;
  width: 100%;
  display: flex;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
  text-transform: uppercase;

  strong {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 400;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.4;
  margin-bottom: 48px;
  text-align: center;
`;


export function Dashboard({ page, ...rest }) {

  const { loggedIn, setLoggedIn, orders, setOrdersPerPage, currentTheme, setResources, setMode, setCurrentRouteName } = useContext(AppContext);
  const [pageOrders, setPageOrders] = useState([]);
  const [cardTables, setCardTables] = useState([]);

  const [orderRowCount, setOrderRowCount] = useState(0);
  const [orderTableCount, setOrderTableCount] = useState(0);

  const { height, width } = useWindowDimensions();
  const history = useHistory();

  // filter out orders for this page number
  useEffect(() => {
    if (!page) return;
    setPageOrders(orders.slice(page.start, page.end + 1));
  }, [page, orders]);

  // group orders for card lists
  useEffect(() => {
    console.log(pageOrders)
    const tables = [];
    for (let i = 0; i < orderTableCount; i++) {
      tables.push({
        orders: pageOrders.slice(i * orderRowCount, (i * orderRowCount) + orderRowCount)
      });
    }
    setCardTables(tables);
  }, [pageOrders]);

  // set orders per page
  useEffect(() => {
    calculatRows();
  }, [height, width]);

  const calculatRows = () => {
    const rowCount = Math.floor((height) / 70) - 1;
    const tableCount = Math.floor(width / 625);

    setOrderRowCount(rowCount);
    setOrderTableCount(tableCount);

    setOrdersPerPage(rowCount * tableCount);
  }

  useEffect(() => {
    setMode(Modes.DRIVER_DASHBOARD);
    setCurrentRouteName(RouteNames.DRIVER_DASHBOARD);

    if (!loggedIn) {
      // history.replace("/kitchenselect");
      setLoggedIn(true);
    }

    fetchStaticResourceMap().then((map) => {
      setResources(map);
    });
  }, []);

  return (
    <div>
      <Header />
      <Wrapper colorTheme={currentTheme.dashboard} height={height} {...rest}>
        <Container>
          {
            cardTables.map(({ orders, i }) => (
              <CardList key={i} orders={orders} />
            ))
          }

        </Container>
      </Wrapper>
      {/* <Footer /> */}
    </div>

  );
}